import _slicedToArray from 'babel-runtime/helpers/slicedToArray';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useQuery } from '@apollo/react-hooks';

import Loading from '../components/Loading/Loading';
import Visualizer from '../containers/Visualizer/Visualizer';

import { GET_VISUALIZER_DATA } from '../Queries';

import { hasSearchQuery } from '../Utils/VisualizerUtils';

var _ref = React.createElement(
  'div',
  { className: 'loading-wrapper' },
  React.createElement(Loading, null)
);

var VisualizerPage = function VisualizerPage(props) {
  var _useState = useState({}),
      _useState2 = _slicedToArray(_useState, 2),
      visData = _useState2[0],
      setVisData = _useState2[1];

  var _useQuery = useQuery(GET_VISUALIZER_DATA, {
    variables: { slug: props.slug, userId: window.Dormify.customerId },
    onCompleted: function onCompleted(data) {
      setVisData(data);
    },
    skip: Object.keys(visData).length // only run on load
  }),
      loading = _useQuery.loading,
      error = _useQuery.error;

  if (loading || !Object.keys(visData).length) return _ref;
  if (error) throw new Error(error);

  var visualizer = visData.visualizerBySlug;

  // Checks whether the visualizer is in staging env
  var isStaging = hasSearchQuery(props.queryParams, 'staging=true');

  var products = isStaging ? visData.products : visData.products.filter(function (p) {
    return p.availableForSale;
  } // hide sold out items
  );
  var rooms = visData.rooms;
  return React.createElement(Visualizer, {
    products: products,
    rooms: rooms,
    addVariantToCart: props.addVariantToCart,
    checkout: props.checkout,
    categoryData: visData.categories,
    queryParams: props.queryParams,
    title: visualizer.title,
    subTitle: visualizer.subTitle,
    categoryHeader: 'Start Decorating',
    user: visData.user,
    toggleAccountModal: props.toggleAccountModal,
    slug: props.slug,
    isStaging: isStaging
  });
};

VisualizerPage.propTypes = {
  addVariantToCart: PropTypes.func.isRequired,
  checkout: PropTypes.object.isRequired,
  queryParams: PropTypes.string,
  slug: PropTypes.string,
  toggleAccountModal: PropTypes.func.isRequired
};

export default VisualizerPage;